<template>
  <core-navigation
    :external-links="externalLinks"
    @route-change="setItemEditors"
  >
    <template v-slot:navbar-buttons>
      <!--Quick Access Buttons -->
      <v-btn
        icon
        @click="oneClickReservation"
      >
        <v-icon color="grey darken-1">
          mdi-clock-fast
        </v-icon>
      </v-btn>
    </template>
    <template v-slot:top-body-content>
      <!-- Global Items -->
      <!-- One Click Dining Reservations -->
      <reservations-item
        v-if="showOcr"
        v-model="ocrId"
        :event-id="ocrEventId"
        :clone-id="ocrCloneId"
        :location-id="ocrLocationId"
        :s-time="ocrTime"
        :s-date="ocrDate"
        :is-walkin="ocrIsWalkin"
        id-query="ocrId"
        clone-id-query="ocrClone"
      />
      <!-- Add event (really need a global events component to house this and all event routes, but don't have one yet) -->
      <events-item
        v-else-if="showQuickEvent"
        v-model="quickEventId"
        :clone-id="quickEventCloneId"
        id-query="quickEventId"
        clone-id-query="quickEventClone"
      />
    </template>
    <router-view />
  </core-navigation>
</template>

<script>
import AppCommon from './AppCommon'
import {CoreNavigation, apiHelpers, itemHelpers} from '@/ft-vue-core'
import ReservationsItem from './components/reservations/ReservationsItem'
import EventsItem from './components/events/EventsItem'

export default {
  name: 'App',
  components: {ReservationsItem, EventsItem, CoreNavigation},
  mixins: [apiHelpers, itemHelpers, AppCommon],
  data () {
    return {
      showOcr: false,
      ocrIsWalkin: undefined,
      ocrEventId: undefined,
      ocrLocationId: undefined,
      ocrTime: undefined,
      ocrDate: undefined,
      ocrId: undefined,
      ocrCloneId: undefined,
      quickEventId: undefined,
      quickEventCloneId: undefined,
      showQuickEvent: false
    }
  },
  computed: {
    externalLinks () {
      return [
        ...this.externalLinksCommon,
        {
          icon: 'mdi-email',
          text: 'Send Email to Members',
          parms: [{parm: 'send_email', value: 1}]
        }, /*
            {
              icon: 'mdi-message-settings-variant',
              text: 'Manage Member Prompt',
              parms: [{parm: 'manage_member_prompts', value: 1}]
            }, */
        {
          icon: 'mdi-view-quilt',
          text: 'Edit Home Page',
          parms: [{parm: 'edit_announce', value: 1}]
        },
        {
          icon: 'mdi-file-pdf-box',
          text: 'Upload PDF',
          parms: [{parm: 'upload_pdf', value: 1}]
        },
        {
          icon: 'mdi-help-box',
          text: 'Help Center',
          parms: [{parm: 'communityLogin', value: 1}]
        }
      ]
    }
  },
  watch: {
    ocrId (val) {
      if (val === undefined) {
        setTimeout(() => {
          if (this.ocrId === undefined) this.showOcr = false
        }, 1000)
      } else {
        this.showOcr = true
      }
    },
    quickEventId (val) {
      if (val === undefined) {
        setTimeout(() => {
          if (this.quickEventId === undefined) this.showQuickEvent = false
        }, 1000)
      } else {
        this.showQuickEvent = true
      }
    }
  },
  mounted () {
    console.warn('Mounted AppDining')
    this.setItemEditors()
  },
  methods: {
    oneClickReservation () {
      let target = this.$ftCS.DINING_ONE_CLICK_TYPE
      if (!target) {
        target = localStorage.getItem('lastReservationType')
      }
      const query = Object.assign({}, this.$route.query)
      query.sxp = 1
      switch (target) {
      case 'EVENT':
        this.$router.push({
          query: {
            ...query,
            ocrId: '',
            ocrEventId: ''
          }
        })
        break

      case 'WALK_IN':
        this.$router.push({
          query: {
            ...query,
            ocrId: '',
            ocrIsWalkin: ''
          }
        })
        break

      default:
        this.$router.push({
          query: {
            ...query,
            ocrId: ''
          }
        })
        break
      }
    },
    setItemEditors () {
      this.setOneClickReservation()
      this.setQuickEvent()
    },
    setOneClickReservation () {
      const ocrId = this.$route.query.ocrId
      if (ocrId !== undefined) {
        this.ocrId = ocrId
        this.showOcr = true
        this.ocrCloneId = this.$route.query.ocrClone
        this.ocrEventId = this.$route.query.ocrEventId
        this.ocrLocationId = this.$route.query.ocrLId
        this.ocrDate = this.$route.query.ocrD
        this.ocrTime = this.$route.query.ocrT
        this.ocrIsWalkin = this.$route.query.ocrIsWalkin
      } else {
        this.ocrId = undefined
      }
    },
    setQuickEvent () {
      const quickEventId = this.$route.query.quickEventId
      if (quickEventId !== undefined) {
        this.quickEventId = quickEventId
        this.showQuickEvent = true
        this.quickEventCloneId = this.$route.query.quickEventClone
      } else {
        this.quickEventId = undefined
      }
    },
    /**
     * Called by Dialogs to check access for linking URLs in put request prompt callbacks
     * returning true allow doApiMessageLink to be called
     *
     * TODO:  Come up with better method for this
     */
    checkApiMessageLink (message, dialog) {
      switch (message.recordType) {
      case 'DiningBlocker':
        // User has access to manage blockers.  Allow linking to blockers
        return this.$ftAccess.manageBlockers
      case 'DiningEvent':
        // User has access to manage events or view reservations.  Allow linking to events
        return this.$ftAccess.viewReservations || this.$ftAccess.manageEvents
      case 'DiningReservation':
        // User has access to view reservations.  Allow linking to reservations
        return this.$ftAccess.viewReservations || this.$ftAccess.manageReservations
      default:
        // Fall back to global handlers
        return this.checkApiMessageLinkCommon(message, dialog)
      }
    },
    /**
     * Called by Dialogs to generate App link URLs in put request prompt callbacks
     * Allows app te generate relative links to components based on ftAPI response data
     *
     * TODO:  Come up with better method for this
     */
    doApiMessageLink (message, dialog) {
      var routeData
      switch (message.recordType) {
      case 'DiningReservation':
        // Link to a list of dining reservations
        routeData = this.$router.resolve({path: '/reservations/upcoming', query: {sxp: 1, showId: message.ids[0], eoc: 1}})
        window.open(routeData.href, '_blank')
        break
      case 'DiningBlocker':
        // Link to a list of blockers
        routeData = this.$router.resolve({path: '/configuration/blockers', query: {sxp: 1, showId: message.ids[0], eoc: 1}})
        window.open(routeData.href, '_blank')
        break
      case 'DiningEvent':
        // Link to a list of events
        routeData = this.$router.resolve({path: '/events/upcoming', query: {sxp: 1, showId: message.ids[0], eoc: 1}})
        window.open(routeData.href, '_blank')
        break
      default:
        // Fall back to global handlers
        return this.doApiMessageLinkCommon(message, dialog)
      }
    }
  }
}
</script>
